import { render, staticRenderFns } from "./KCWalletPassSelector.vue?vue&type=template&id=e1b993ae&"
import script from "./KCWalletPassSelector.vue?vue&type=script&lang=js&"
export * from "./KCWalletPassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports